import { Component, OnInit, Input } from '@angular/core';
import { ReactiveFormsModule, ControlContainer, FormGroupDirective } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'marv-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  imports: [ReactiveFormsModule],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class MarvRadioComponent  implements OnInit {

    @Input({alias : 'label', required : false}) labelRadio: string = '';
    @Input({alias : 'value', required : false}) valueRadio: string|number = 1;
    @Input({alias : 'formName', required : false}) formName: string = '';
    @Input({alias : 'inline', required : false}) inlineRadio: boolean = false;
    @Input({alias : 'labelPlacement', required : false}) labelPlacement: 'start'|'end' = 'start';
    @Input({alias : 'errorText', required : false}) errorText: string = this.translateService.instant('MSG_ERROR_FIELD_MANDATORY');

    constructor(
        public translateService: TranslateService,
        public formGroupDirective: FormGroupDirective
    ) {}

    ngOnInit() {}

}
